export const GUTTER = 15;
export const BORDER_RADIUS = 6;
